export enum StatusMatriculaEnum {
  Prematriculado = 'PREMATRICULADO',
  Matriculado = 'MATRICULADO',
  Cancelado = 'CANCELADO',
  Concluido = 'CONCLUIDO',
}
